import React from 'react';
import { Helmet } from 'react-helmet-async';
import { initializeAnalytics } from '@scrippsproduct/networks-ui-library/dist/utils/analytics'

const ENV = process.env.REACT_APP_ENV
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID 

export default function SEO({ 
    title, 
    description = 'Laff is your destination for comedy around the clock, featuring a 24/7 lineup of fan-favorite sitcoms and movies starring some of television’s funniest talent.',
    name = 'Laff',
    url = 'https://www.laff.com',
    siteName = 'Laff',
    image = null, 
    favicon = null,
    type = 'article', 
    robots = 'index' 
}) {
    console.log('SEO favicon', favicon);
    return (
        // `onChangeClientState` callback initializes Google Analytics.
        // This happens after the page's metadata (including the `<title>` tag) is updated, 
        // ensuring that the page title is accurately tracked in GA4.
         <Helmet onChangeClientState={() => initializeAnalytics(name, ENV, GA_ID)}>
            { /* Standard metadata tags */ }
            <title>{title}</title>
            <meta name='description' content={description} />
            { (favicon !== null) && <link rel="icon" href={`/${favicon}.ico`} /> }
            { (favicon !== null) && <link rel="icon" type="image/png" sizes="16x16" href={`/${favicon}-16x16.png`} /> }
            { (favicon !== null) && <link rel="icon" sizes="32x32" href={`/${favicon}-32x32.png`} /> }
            { (favicon !== null) && <link rel="icon" sizes="192x192" href={`/${favicon}-192x192.png`} /> }
            { (favicon !== null) && <link rel="icon" sizes="512x512" href={`/${favicon}-512x512.png`} /> }
            { (favicon !== null) && <link rel="apple-touch-icon" href={`/${favicon}.png`} /> }
            { (favicon !== null) && <link rel="apple-touch-icon" sizes="192x192" href={`/${favicon}-192x192.png`} /> }
            { (favicon !== null) && <link rel="apple-touch-icon" sizes="512x512" href={`/${favicon}-512x512.png`} /> }

            { /* Facebook tags */ }
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:site_name" content={siteName} />
            { (image !== null) && <meta property="og:image" content={image}/> }

            { /* Twitter tags */ }
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            { (image !== null) && <meta name="twitter:image" content={image} /> }

            <meta name="robots" content={robots} />
        </Helmet>
    )
}